import React from 'react'
import { ToggleButton, ToggleButtonGroup, Box, useTheme } from '@mui/material'
import { useLanguage } from '../context/LanguageContext'

interface LanguageToggleProps {
  variant?: 'default' | 'compact'
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ variant = 'default' }) => {
  const { language, setLanguage } = useLanguage()
  const theme = useTheme()

  const handleChange = (_event: React.MouseEvent<HTMLElement>, newLanguage: 'en' | 'cy' | null) => {
    if (newLanguage !== null) {
      setLanguage(newLanguage)
    }
  }

  if (variant === 'compact') {
    return (
      <ToggleButtonGroup
        value={language}
        exclusive
        onChange={handleChange}
        aria-label="language selection"
        size="small"
        sx={{
          bgcolor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: 1,
          '& .MuiToggleButtonGroup-grouped': {
            border: 'none',
            borderRadius: 1,
            px: 1.5,
            py: 0.5,
            color: 'rgba(255, 255, 255, 0.7)',
            fontWeight: 600,
            fontSize: '0.75rem',
            minWidth: 36,
            '&.Mui-selected': {
              bgcolor: theme.palette.primary.main,
              color: 'white',
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
              }
            },
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.15)',
            }
          }
        }}
      >
        <ToggleButton value="en" aria-label="English">
          EN
        </ToggleButton>
        <ToggleButton value="cy" aria-label="Cymraeg">
          CY
        </ToggleButton>
      </ToggleButtonGroup>
    )
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <ToggleButtonGroup
        value={language}
        exclusive
        onChange={handleChange}
        aria-label="language selection"
        sx={{
          bgcolor: 'rgba(0, 132, 61, 0.08)',
          borderRadius: 2,
          border: '1px solid rgba(0, 132, 61, 0.2)',
          '& .MuiToggleButtonGroup-grouped': {
            border: 'none',
            borderRadius: 2,
            px: 2,
            py: 1,
            color: theme.palette.text.secondary,
            fontWeight: 600,
            fontSize: '0.875rem',
            minWidth: 60,
            transition: 'all 0.2s ease',
            '&.Mui-selected': {
              bgcolor: theme.palette.primary.main,
              color: 'white',
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
              }
            },
            '&:hover': {
              bgcolor: 'rgba(0, 132, 61, 0.12)',
            }
          }
        }}
      >
        <ToggleButton value="en" aria-label="English">
          🏴󠁧󠁢󠁥󠁮󠁧󠁿 English
        </ToggleButton>
        <ToggleButton value="cy" aria-label="Cymraeg">
          🏴󠁧󠁢󠁷󠁬󠁳󠁿 Cymraeg
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )
}

export default LanguageToggle
